
const FormRow = ({ type, name, value, handleChange, placeholder, required }) => {
  return (
    <div className="form-row">
      <label className="form-label">{name}</label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={handleChange}
        className="form-input"
        placeholder={placeholder}
        required={required}
      />
    </div>
  );
};
export default FormRow;
